import { supabase } from '@/integrations/supabase/client';
import { PlayerRanking, PlayerActivity } from '@/types/stats';

export class PlayerStatsService {
  async getRankings(): Promise<PlayerRanking[]> {
    const { data, error } = await supabase
      .from('player_rankings_v')
      .select(
        `user_id, name, phone, rating, rating_deviation, events_played, events_unique, last_event_at`
      )
      .order('rating', { ascending: false });

    if (error) throw error;
    return (data || []).map((row: any) => ({
      player_id: row.user_id,
      member_id: row.user_id,
      name: row.name,
      phone: row.phone ?? undefined,
      rating: Number(row.rating ?? 0),
      rating_deviation: Number(row.rating_deviation ?? 0),
      reliability: 0, // Not available in view
      level: 'level_1', // Not available in view
      matches_played: Number(row.events_played ?? 0),
      tournament_matches: Number(row.events_unique ?? 0),
      last_activity_at: row.last_event_at ?? null,
      last_rating_delta: 0, // Not available in view
    }));
  }

  async getRecentActivity(userId: string, limit = 5): Promise<PlayerActivity[]> {
    if (!userId) {
      return [];
    }
    const { data, error } = await supabase
      .from('event_participants')
      .select(
        `
        event_id,
        joined_at,
        events:events (
          id,
          title,
          description,
          event_date,
          event_time,
          location,
          group_key,
          group_id
        )
      `
      )
      .eq('user_id', userId)
      .order('joined_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return (data || []).map((row: any) => {
      const event = row.events ?? {};
      return {
        event_id: row.event_id,
        title: event.title ?? 'Unnamed session',
        event_date: event.event_date,
        event_time: event.event_time,
        location: event.location,
        group_name: event.group_key ?? null,
        joined_at: row.joined_at,
      } as PlayerActivity;
    });
  }
}
